// 修改密码
<template>
   <div style="height: 100%; background: #253746;">
      <Header></Header>
      <div style="width: 80%;background: #fff;border-radius: 8px;height: 500px;margin: 120px auto;">
         <el-steps :active="active" style="width: 80%;margin: 0 auto;padding-top: 50px;" :align-center="true">
            <el-step title="校验身份" icon="el-icon-edit"> </el-step>
            <el-step title="设置密码" icon="el-icon-upload"></el-step>
            <el-step title="重置成功" icon="el-icon-picture"></el-step>
         </el-steps>
         <!-- <el-steps :active="1" simple>
            <el-step title="校验身份" icon="el-icon-edit"></el-step>
            <el-step title="设置密码" icon="el-icon-upload"></el-step>
            <el-step title="重置成功" icon="el-icon-picture"></el-step>
         </el-steps> -->
         <div class="ac mt80" v-if="active == 1">
            <span class="mr20">用户名</span>
            <vxe-input :class="{ 'apply-shake': isShakeTextName }" readonly v-model="username" prefix-icon="iconfont icon-yonghu" size="mini" placeholder="请输入用户名" :align="'center'"></vxe-input>
            <span class="mr20 mL20">原始密码</span>
            <vxe-input :class="{ 'apply-shake': isShakeTextName }" v-model="oldPassword" type="password" prefix-icon="iconfont icon-yuanshimima1" size="mini" placeholder="请输入原始密码" :align="'center'"></vxe-input>
            <span style="font-size: 12px;color: red;" v-if="oldPasswordTips">原始账户或密码错误！</span>
            <vxe-button size="mini" icon="vxe-icon--check" class="co-f relative" status="primary" style="bottom: 1px" @click="next">确定</vxe-button>
         </div>
         <div class="ac mt80" v-if="active == 2">
            <span class="mr20">新密码</span>
            <vxe-input ref="oldPasswordRef" v-model="newPassword" type="password" prefix-icon="iconfont icon-yiliaohangyedeICON-" size="mini" placeholder="请输入新密码" :align="'center'"></vxe-input>
            <span style="font-size: 12px;color: red;" v-if="tipsPassword">请输入新密码！</span>
            <span class="mr20 mL20">确认新密码</span>
            <vxe-input ref="newPasswordRef" v-model="confirmNewPassword" type="password" prefix-icon="iconfont icon-querenmima" size="mini" placeholder="请确认新密码" :align="'center'"></vxe-input>
            <span style="font-size: 12px;color: red;" v-if="tips">两次输入的密码不一致！</span>
            <span style="font-size: 12px;color: red;" v-if="tipsConfirmPassword">请确认新密码！</span>
            <vxe-button size="mini" icon="vxe-icon--check" class="co-f relative" status="primary" style="bottom: 1px;" @click="ensureNewPassword">确定</vxe-button>
         </div>
         <div class="ac" v-if="active == 3">
            <span class="iconfont icon-mimaxiugaichenggongtishiicon" style="font-size: 80px;"></span>
            <!-- <p>修改成功，去<span class="color-primary cursor" @click="toLogin">登录</span></p> -->
            <p class="color-primary">修改成功！</p>
         </div>
      </div>
   </div>
</template>

<script>
import Header from './Header.vue'
export default {
   components: { Header },
   data () {
      return {
         active: 1,
         username: '',
         oldPassword: '',
         newPassword: '',
         confirmNewPassword: '',
         tips: false,
         tipsPassword: false,
         tipsConfirmPassword: false,
         oldPasswordTips: false,
         isShakeTextName: false,
      }
   },
   mounted () {
      this.username = localStorage.getItem('username')
   },
   methods: {
      toLogin () {
         this.$router.push({ name: 'Login' })
      },
      next () {
         if (this.username === '' || this.oldPassword === '') {
            this.isShakeTextName = true
            setTimeout(() => {
               this.isShakeTextName = false
            }, 820)
            return
         }
         const url = this.$api.VerifyPassword
         const params = {
            'email': this.username,
            'password': this.oldPassword
         }
         const header = { 'token': `Bearer ${localStorage.getItem('token')}` }
         this.$http.post(url, params, header, window._env_.api_url, res => {
            if (res.status >= 200 && res.status < 300) {
               if (res.data.message == 'Email verification error') {
                  this.oldPasswordTips = true
                  this.isShakeTextName = true
                  setTimeout(() => {
                     this.isShakeTextName = false
                  }, 820)
               } else {
                  if (this.active++ > 2) this.active = 0;
               }
            }
         })
      },
      // 确认新密码
      ensureNewPassword () {
         if (this.newPassword === '') {
            this.tipsPassword = true
            this.$refs.oldPasswordRef.focus()
         } else if (this.confirmNewPassword === '') {
            this.tipsConfirmPassword = true
            this.tipsPassword = false
            this.tips = false
            this.$refs.newPasswordRef.focus()
         } else if (this.newPassword !== this.confirmNewPassword) {
            this.$refs.newPasswordRef.focus()
            this.tipsConfirmPassword = false
            this.tips = true
         } else {
            this.tipsConfirmPassword = false
            this.tipsPassword = false
            this.tips = false
            const url = this.$api.ResetPassword
            const params = {
               'password': this.newPassword,
               'email': this.username,
               "is_active": true,
               "is_superuser": true,
               "is_verified": true
            }
            const header = { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            this.$http.patch(url, params, header, window._env_.api_url, res => {
               if (res.status >= 200 && res.status < 300) {
                  if (this.active++ > 2) this.active = 0;
               }
            })
            // this.next()
         }
      }
   }
}
</script>

<style>
@keyframes shake {

   10%,
   90% {
      transform: translate3d(-1px, 0, 0);
   }

   20%,
   80% {
      transform: translate3d(2px, 0, 0);
   }

   30%,
   50%,
   70% {
      transform: translate3d(-4px, 0, 0)
   }

   40%,
   60% {
      transform: translate3d(4px, 0, 0);
   }
}

.apply-shake {
   animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

.apply-shake>input {
   border: 1px solid red;
}

.vxe-input {
   width: 230px;
}

/* .vxe-button.type--button.theme--primary:not(.is--disabled){
   border-color: #c90a5b;
   background-color: #c90a5b;
} */

</style>


// WEBPACK FOOTER //
// src/components/ResetPassword.vue